/* eslint-disable */
import Long from 'long';
import * as _m0 from 'protobufjs/minimal';
import {
  CustomerContext,
  CampaignContext,
  LeadContext,
  SellDirectContext,
  AdClickContext,
} from '../../../protobuf/journey/data/contexts';
import { Timestamp } from '../../../google/protobuf/timestamp';
import { WebsiteSource, BackendSource } from '../../../protobuf/journey/data/sources';
import {
  ButtonClickEvent,
  ButtonViewEvent,
  ButtonHoverEvent,
  LinkClickEvent,
  LinkViewEvent,
  LinkHoverEvent,
  CheckboxClickEvent,
  CheckboxViewEvent,
  CheckboxHoverEvent,
  RadioClickEvent,
  RadioViewEvent,
  RadioHoverEvent,
  InputViewEvent,
  InputHoverEvent,
  InputBlurEvent,
  InputFocusEvent,
  AccordionClickEvent,
  AccordionViewEvent,
  AccordionHoverEvent,
  BoxViewEvent,
  CardViewEvent,
  TextViewEvent,
  ImageViewEvent,
  PageViewEvent,
  ExternalLeadGeneratedEvent,
  OutreachEvent,
} from '../../../protobuf/journey/data/events';
import {
  SellDirectConversionEvent,
  SellerInputEvent,
} from '../../../protobuf/journey/data/conversion_events';
import { PartnerEvent } from '../../../protobuf/journey/data/partner_events';

export const protobufPackage = 'od_protos.journey.data';

/** Next ID: 41 */
export interface UserEvent {
  uuid: string;
  timestamp?: Date;
  anonymousId?: string;
  humanId?: string;
  source?:
    | { $case: 'websiteSource'; websiteSource: WebsiteSource }
    | { $case: 'backendSource'; backendSource: BackendSource };
  event?:
    | { $case: 'buttonClickEvent'; buttonClickEvent: ButtonClickEvent }
    | { $case: 'buttonViewEvent'; buttonViewEvent: ButtonViewEvent }
    | { $case: 'buttonHoverEvent'; buttonHoverEvent: ButtonHoverEvent }
    | { $case: 'linkClickEvent'; linkClickEvent: LinkClickEvent }
    | { $case: 'linkViewEvent'; linkViewEvent: LinkViewEvent }
    | { $case: 'linkHoverEvent'; linkHoverEvent: LinkHoverEvent }
    | { $case: 'checkboxClickEvent'; checkboxClickEvent: CheckboxClickEvent }
    | { $case: 'checkboxViewEvent'; checkboxViewEvent: CheckboxViewEvent }
    | { $case: 'checkboxHoverEvent'; checkboxHoverEvent: CheckboxHoverEvent }
    | { $case: 'radioClickEvent'; radioClickEvent: RadioClickEvent }
    | { $case: 'radioViewEvent'; radioViewEvent: RadioViewEvent }
    | { $case: 'radioHoverEvent'; radioHoverEvent: RadioHoverEvent }
    | { $case: 'inputViewEvent'; inputViewEvent: InputViewEvent }
    | { $case: 'inputHoverEvent'; inputHoverEvent: InputHoverEvent }
    | { $case: 'inputBlurEvent'; inputBlurEvent: InputBlurEvent }
    | { $case: 'inputFocusEvent'; inputFocusEvent: InputFocusEvent }
    | { $case: 'accordionClickEvent'; accordionClickEvent: AccordionClickEvent }
    | { $case: 'accordionViewEvent'; accordionViewEvent: AccordionViewEvent }
    | { $case: 'accordionHoverEvent'; accordionHoverEvent: AccordionHoverEvent }
    | { $case: 'boxViewEvent'; boxViewEvent: BoxViewEvent }
    | { $case: 'cardViewEvent'; cardViewEvent: CardViewEvent }
    | { $case: 'textViewEvent'; textViewEvent: TextViewEvent }
    | { $case: 'imageViewEvent'; imageViewEvent: ImageViewEvent }
    | { $case: 'pageViewEvent'; pageViewEvent: PageViewEvent }
    | { $case: 'sellDirectConversionEvent'; sellDirectConversionEvent: SellDirectConversionEvent }
    | {
        $case: 'externalLeadGeneratedEvent';
        externalLeadGeneratedEvent: ExternalLeadGeneratedEvent;
      }
    | { $case: 'sellerInputEvent'; sellerInputEvent: SellerInputEvent }
    | { $case: 'partnerEvent'; partnerEvent: PartnerEvent }
    | { $case: 'outreachEvent'; outreachEvent: OutreachEvent };
  customerContext?: CustomerContext;
  campaignContext?: CampaignContext;
  leadContext?: LeadContext;
  sellDirectContext?: SellDirectContext;
  adClickContext?: AdClickContext;
}

function createBaseUserEvent(): UserEvent {
  return {
    uuid: '',
    timestamp: undefined,
    anonymousId: undefined,
    humanId: undefined,
    source: undefined,
    event: undefined,
    customerContext: undefined,
    campaignContext: undefined,
    leadContext: undefined,
    sellDirectContext: undefined,
    adClickContext: undefined,
  };
}

export const UserEvent = {
  fromJSON(object: any): UserEvent {
    return {
      uuid: isSet(object.uuid) ? String(object.uuid) : '',
      timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
      anonymousId: isSet(object.anonymousId) ? String(object.anonymousId) : undefined,
      humanId: isSet(object.humanId) ? String(object.humanId) : undefined,
      source: isSet(object.websiteSource)
        ? { $case: 'websiteSource', websiteSource: WebsiteSource.fromJSON(object.websiteSource) }
        : isSet(object.backendSource)
        ? { $case: 'backendSource', backendSource: BackendSource.fromJSON(object.backendSource) }
        : undefined,
      event: isSet(object.buttonClickEvent)
        ? {
            $case: 'buttonClickEvent',
            buttonClickEvent: ButtonClickEvent.fromJSON(object.buttonClickEvent),
          }
        : isSet(object.buttonViewEvent)
        ? {
            $case: 'buttonViewEvent',
            buttonViewEvent: ButtonViewEvent.fromJSON(object.buttonViewEvent),
          }
        : isSet(object.buttonHoverEvent)
        ? {
            $case: 'buttonHoverEvent',
            buttonHoverEvent: ButtonHoverEvent.fromJSON(object.buttonHoverEvent),
          }
        : isSet(object.linkClickEvent)
        ? {
            $case: 'linkClickEvent',
            linkClickEvent: LinkClickEvent.fromJSON(object.linkClickEvent),
          }
        : isSet(object.linkViewEvent)
        ? { $case: 'linkViewEvent', linkViewEvent: LinkViewEvent.fromJSON(object.linkViewEvent) }
        : isSet(object.linkHoverEvent)
        ? {
            $case: 'linkHoverEvent',
            linkHoverEvent: LinkHoverEvent.fromJSON(object.linkHoverEvent),
          }
        : isSet(object.checkboxClickEvent)
        ? {
            $case: 'checkboxClickEvent',
            checkboxClickEvent: CheckboxClickEvent.fromJSON(object.checkboxClickEvent),
          }
        : isSet(object.checkboxViewEvent)
        ? {
            $case: 'checkboxViewEvent',
            checkboxViewEvent: CheckboxViewEvent.fromJSON(object.checkboxViewEvent),
          }
        : isSet(object.checkboxHoverEvent)
        ? {
            $case: 'checkboxHoverEvent',
            checkboxHoverEvent: CheckboxHoverEvent.fromJSON(object.checkboxHoverEvent),
          }
        : isSet(object.radioClickEvent)
        ? {
            $case: 'radioClickEvent',
            radioClickEvent: RadioClickEvent.fromJSON(object.radioClickEvent),
          }
        : isSet(object.radioViewEvent)
        ? {
            $case: 'radioViewEvent',
            radioViewEvent: RadioViewEvent.fromJSON(object.radioViewEvent),
          }
        : isSet(object.radioHoverEvent)
        ? {
            $case: 'radioHoverEvent',
            radioHoverEvent: RadioHoverEvent.fromJSON(object.radioHoverEvent),
          }
        : isSet(object.inputViewEvent)
        ? {
            $case: 'inputViewEvent',
            inputViewEvent: InputViewEvent.fromJSON(object.inputViewEvent),
          }
        : isSet(object.inputHoverEvent)
        ? {
            $case: 'inputHoverEvent',
            inputHoverEvent: InputHoverEvent.fromJSON(object.inputHoverEvent),
          }
        : isSet(object.inputBlurEvent)
        ? {
            $case: 'inputBlurEvent',
            inputBlurEvent: InputBlurEvent.fromJSON(object.inputBlurEvent),
          }
        : isSet(object.inputFocusEvent)
        ? {
            $case: 'inputFocusEvent',
            inputFocusEvent: InputFocusEvent.fromJSON(object.inputFocusEvent),
          }
        : isSet(object.accordionClickEvent)
        ? {
            $case: 'accordionClickEvent',
            accordionClickEvent: AccordionClickEvent.fromJSON(object.accordionClickEvent),
          }
        : isSet(object.accordionViewEvent)
        ? {
            $case: 'accordionViewEvent',
            accordionViewEvent: AccordionViewEvent.fromJSON(object.accordionViewEvent),
          }
        : isSet(object.accordionHoverEvent)
        ? {
            $case: 'accordionHoverEvent',
            accordionHoverEvent: AccordionHoverEvent.fromJSON(object.accordionHoverEvent),
          }
        : isSet(object.boxViewEvent)
        ? { $case: 'boxViewEvent', boxViewEvent: BoxViewEvent.fromJSON(object.boxViewEvent) }
        : isSet(object.cardViewEvent)
        ? { $case: 'cardViewEvent', cardViewEvent: CardViewEvent.fromJSON(object.cardViewEvent) }
        : isSet(object.textViewEvent)
        ? { $case: 'textViewEvent', textViewEvent: TextViewEvent.fromJSON(object.textViewEvent) }
        : isSet(object.imageViewEvent)
        ? {
            $case: 'imageViewEvent',
            imageViewEvent: ImageViewEvent.fromJSON(object.imageViewEvent),
          }
        : isSet(object.pageViewEvent)
        ? { $case: 'pageViewEvent', pageViewEvent: PageViewEvent.fromJSON(object.pageViewEvent) }
        : isSet(object.sellDirectConversionEvent)
        ? {
            $case: 'sellDirectConversionEvent',
            sellDirectConversionEvent: SellDirectConversionEvent.fromJSON(
              object.sellDirectConversionEvent,
            ),
          }
        : isSet(object.externalLeadGeneratedEvent)
        ? {
            $case: 'externalLeadGeneratedEvent',
            externalLeadGeneratedEvent: ExternalLeadGeneratedEvent.fromJSON(
              object.externalLeadGeneratedEvent,
            ),
          }
        : isSet(object.sellerInputEvent)
        ? {
            $case: 'sellerInputEvent',
            sellerInputEvent: SellerInputEvent.fromJSON(object.sellerInputEvent),
          }
        : isSet(object.partnerEvent)
        ? { $case: 'partnerEvent', partnerEvent: PartnerEvent.fromJSON(object.partnerEvent) }
        : isSet(object.outreachEvent)
        ? { $case: 'outreachEvent', outreachEvent: OutreachEvent.fromJSON(object.outreachEvent) }
        : undefined,
      customerContext: isSet(object.customerContext)
        ? CustomerContext.fromJSON(object.customerContext)
        : undefined,
      campaignContext: isSet(object.campaignContext)
        ? CampaignContext.fromJSON(object.campaignContext)
        : undefined,
      leadContext: isSet(object.leadContext) ? LeadContext.fromJSON(object.leadContext) : undefined,
      sellDirectContext: isSet(object.sellDirectContext)
        ? SellDirectContext.fromJSON(object.sellDirectContext)
        : undefined,
      adClickContext: isSet(object.adClickContext)
        ? AdClickContext.fromJSON(object.adClickContext)
        : undefined,
    };
  },

  toJSON(message: UserEvent): unknown {
    const obj: any = {};
    message.uuid !== undefined && (obj.uuid = message.uuid);
    message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
    message.anonymousId !== undefined && (obj.anonymousId = message.anonymousId);
    message.humanId !== undefined && (obj.humanId = message.humanId);
    message.source?.$case === 'websiteSource' &&
      (obj.websiteSource = message.source?.websiteSource
        ? WebsiteSource.toJSON(message.source?.websiteSource)
        : undefined);
    message.source?.$case === 'backendSource' &&
      (obj.backendSource = message.source?.backendSource
        ? BackendSource.toJSON(message.source?.backendSource)
        : undefined);
    message.event?.$case === 'buttonClickEvent' &&
      (obj.buttonClickEvent = message.event?.buttonClickEvent
        ? ButtonClickEvent.toJSON(message.event?.buttonClickEvent)
        : undefined);
    message.event?.$case === 'buttonViewEvent' &&
      (obj.buttonViewEvent = message.event?.buttonViewEvent
        ? ButtonViewEvent.toJSON(message.event?.buttonViewEvent)
        : undefined);
    message.event?.$case === 'buttonHoverEvent' &&
      (obj.buttonHoverEvent = message.event?.buttonHoverEvent
        ? ButtonHoverEvent.toJSON(message.event?.buttonHoverEvent)
        : undefined);
    message.event?.$case === 'linkClickEvent' &&
      (obj.linkClickEvent = message.event?.linkClickEvent
        ? LinkClickEvent.toJSON(message.event?.linkClickEvent)
        : undefined);
    message.event?.$case === 'linkViewEvent' &&
      (obj.linkViewEvent = message.event?.linkViewEvent
        ? LinkViewEvent.toJSON(message.event?.linkViewEvent)
        : undefined);
    message.event?.$case === 'linkHoverEvent' &&
      (obj.linkHoverEvent = message.event?.linkHoverEvent
        ? LinkHoverEvent.toJSON(message.event?.linkHoverEvent)
        : undefined);
    message.event?.$case === 'checkboxClickEvent' &&
      (obj.checkboxClickEvent = message.event?.checkboxClickEvent
        ? CheckboxClickEvent.toJSON(message.event?.checkboxClickEvent)
        : undefined);
    message.event?.$case === 'checkboxViewEvent' &&
      (obj.checkboxViewEvent = message.event?.checkboxViewEvent
        ? CheckboxViewEvent.toJSON(message.event?.checkboxViewEvent)
        : undefined);
    message.event?.$case === 'checkboxHoverEvent' &&
      (obj.checkboxHoverEvent = message.event?.checkboxHoverEvent
        ? CheckboxHoverEvent.toJSON(message.event?.checkboxHoverEvent)
        : undefined);
    message.event?.$case === 'radioClickEvent' &&
      (obj.radioClickEvent = message.event?.radioClickEvent
        ? RadioClickEvent.toJSON(message.event?.radioClickEvent)
        : undefined);
    message.event?.$case === 'radioViewEvent' &&
      (obj.radioViewEvent = message.event?.radioViewEvent
        ? RadioViewEvent.toJSON(message.event?.radioViewEvent)
        : undefined);
    message.event?.$case === 'radioHoverEvent' &&
      (obj.radioHoverEvent = message.event?.radioHoverEvent
        ? RadioHoverEvent.toJSON(message.event?.radioHoverEvent)
        : undefined);
    message.event?.$case === 'inputViewEvent' &&
      (obj.inputViewEvent = message.event?.inputViewEvent
        ? InputViewEvent.toJSON(message.event?.inputViewEvent)
        : undefined);
    message.event?.$case === 'inputHoverEvent' &&
      (obj.inputHoverEvent = message.event?.inputHoverEvent
        ? InputHoverEvent.toJSON(message.event?.inputHoverEvent)
        : undefined);
    message.event?.$case === 'inputBlurEvent' &&
      (obj.inputBlurEvent = message.event?.inputBlurEvent
        ? InputBlurEvent.toJSON(message.event?.inputBlurEvent)
        : undefined);
    message.event?.$case === 'inputFocusEvent' &&
      (obj.inputFocusEvent = message.event?.inputFocusEvent
        ? InputFocusEvent.toJSON(message.event?.inputFocusEvent)
        : undefined);
    message.event?.$case === 'accordionClickEvent' &&
      (obj.accordionClickEvent = message.event?.accordionClickEvent
        ? AccordionClickEvent.toJSON(message.event?.accordionClickEvent)
        : undefined);
    message.event?.$case === 'accordionViewEvent' &&
      (obj.accordionViewEvent = message.event?.accordionViewEvent
        ? AccordionViewEvent.toJSON(message.event?.accordionViewEvent)
        : undefined);
    message.event?.$case === 'accordionHoverEvent' &&
      (obj.accordionHoverEvent = message.event?.accordionHoverEvent
        ? AccordionHoverEvent.toJSON(message.event?.accordionHoverEvent)
        : undefined);
    message.event?.$case === 'boxViewEvent' &&
      (obj.boxViewEvent = message.event?.boxViewEvent
        ? BoxViewEvent.toJSON(message.event?.boxViewEvent)
        : undefined);
    message.event?.$case === 'cardViewEvent' &&
      (obj.cardViewEvent = message.event?.cardViewEvent
        ? CardViewEvent.toJSON(message.event?.cardViewEvent)
        : undefined);
    message.event?.$case === 'textViewEvent' &&
      (obj.textViewEvent = message.event?.textViewEvent
        ? TextViewEvent.toJSON(message.event?.textViewEvent)
        : undefined);
    message.event?.$case === 'imageViewEvent' &&
      (obj.imageViewEvent = message.event?.imageViewEvent
        ? ImageViewEvent.toJSON(message.event?.imageViewEvent)
        : undefined);
    message.event?.$case === 'pageViewEvent' &&
      (obj.pageViewEvent = message.event?.pageViewEvent
        ? PageViewEvent.toJSON(message.event?.pageViewEvent)
        : undefined);
    message.event?.$case === 'sellDirectConversionEvent' &&
      (obj.sellDirectConversionEvent = message.event?.sellDirectConversionEvent
        ? SellDirectConversionEvent.toJSON(message.event?.sellDirectConversionEvent)
        : undefined);
    message.event?.$case === 'externalLeadGeneratedEvent' &&
      (obj.externalLeadGeneratedEvent = message.event?.externalLeadGeneratedEvent
        ? ExternalLeadGeneratedEvent.toJSON(message.event?.externalLeadGeneratedEvent)
        : undefined);
    message.event?.$case === 'sellerInputEvent' &&
      (obj.sellerInputEvent = message.event?.sellerInputEvent
        ? SellerInputEvent.toJSON(message.event?.sellerInputEvent)
        : undefined);
    message.event?.$case === 'partnerEvent' &&
      (obj.partnerEvent = message.event?.partnerEvent
        ? PartnerEvent.toJSON(message.event?.partnerEvent)
        : undefined);
    message.event?.$case === 'outreachEvent' &&
      (obj.outreachEvent = message.event?.outreachEvent
        ? OutreachEvent.toJSON(message.event?.outreachEvent)
        : undefined);
    message.customerContext !== undefined &&
      (obj.customerContext = message.customerContext
        ? CustomerContext.toJSON(message.customerContext)
        : undefined);
    message.campaignContext !== undefined &&
      (obj.campaignContext = message.campaignContext
        ? CampaignContext.toJSON(message.campaignContext)
        : undefined);
    message.leadContext !== undefined &&
      (obj.leadContext = message.leadContext ? LeadContext.toJSON(message.leadContext) : undefined);
    message.sellDirectContext !== undefined &&
      (obj.sellDirectContext = message.sellDirectContext
        ? SellDirectContext.toJSON(message.sellDirectContext)
        : undefined);
    message.adClickContext !== undefined &&
      (obj.adClickContext = message.adClickContext
        ? AdClickContext.toJSON(message.adClickContext)
        : undefined);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<UserEvent>, I>>(object: I): UserEvent {
    const message = createBaseUserEvent();
    message.uuid = object.uuid ?? '';
    message.timestamp = object.timestamp ?? undefined;
    message.anonymousId = object.anonymousId ?? undefined;
    message.humanId = object.humanId ?? undefined;
    if (
      object.source?.$case === 'websiteSource' &&
      object.source?.websiteSource !== undefined &&
      object.source?.websiteSource !== null
    ) {
      message.source = {
        $case: 'websiteSource',
        websiteSource: WebsiteSource.fromPartial(object.source.websiteSource),
      };
    }
    if (
      object.source?.$case === 'backendSource' &&
      object.source?.backendSource !== undefined &&
      object.source?.backendSource !== null
    ) {
      message.source = {
        $case: 'backendSource',
        backendSource: BackendSource.fromPartial(object.source.backendSource),
      };
    }
    if (
      object.event?.$case === 'buttonClickEvent' &&
      object.event?.buttonClickEvent !== undefined &&
      object.event?.buttonClickEvent !== null
    ) {
      message.event = {
        $case: 'buttonClickEvent',
        buttonClickEvent: ButtonClickEvent.fromPartial(object.event.buttonClickEvent),
      };
    }
    if (
      object.event?.$case === 'buttonViewEvent' &&
      object.event?.buttonViewEvent !== undefined &&
      object.event?.buttonViewEvent !== null
    ) {
      message.event = {
        $case: 'buttonViewEvent',
        buttonViewEvent: ButtonViewEvent.fromPartial(object.event.buttonViewEvent),
      };
    }
    if (
      object.event?.$case === 'buttonHoverEvent' &&
      object.event?.buttonHoverEvent !== undefined &&
      object.event?.buttonHoverEvent !== null
    ) {
      message.event = {
        $case: 'buttonHoverEvent',
        buttonHoverEvent: ButtonHoverEvent.fromPartial(object.event.buttonHoverEvent),
      };
    }
    if (
      object.event?.$case === 'linkClickEvent' &&
      object.event?.linkClickEvent !== undefined &&
      object.event?.linkClickEvent !== null
    ) {
      message.event = {
        $case: 'linkClickEvent',
        linkClickEvent: LinkClickEvent.fromPartial(object.event.linkClickEvent),
      };
    }
    if (
      object.event?.$case === 'linkViewEvent' &&
      object.event?.linkViewEvent !== undefined &&
      object.event?.linkViewEvent !== null
    ) {
      message.event = {
        $case: 'linkViewEvent',
        linkViewEvent: LinkViewEvent.fromPartial(object.event.linkViewEvent),
      };
    }
    if (
      object.event?.$case === 'linkHoverEvent' &&
      object.event?.linkHoverEvent !== undefined &&
      object.event?.linkHoverEvent !== null
    ) {
      message.event = {
        $case: 'linkHoverEvent',
        linkHoverEvent: LinkHoverEvent.fromPartial(object.event.linkHoverEvent),
      };
    }
    if (
      object.event?.$case === 'checkboxClickEvent' &&
      object.event?.checkboxClickEvent !== undefined &&
      object.event?.checkboxClickEvent !== null
    ) {
      message.event = {
        $case: 'checkboxClickEvent',
        checkboxClickEvent: CheckboxClickEvent.fromPartial(object.event.checkboxClickEvent),
      };
    }
    if (
      object.event?.$case === 'checkboxViewEvent' &&
      object.event?.checkboxViewEvent !== undefined &&
      object.event?.checkboxViewEvent !== null
    ) {
      message.event = {
        $case: 'checkboxViewEvent',
        checkboxViewEvent: CheckboxViewEvent.fromPartial(object.event.checkboxViewEvent),
      };
    }
    if (
      object.event?.$case === 'checkboxHoverEvent' &&
      object.event?.checkboxHoverEvent !== undefined &&
      object.event?.checkboxHoverEvent !== null
    ) {
      message.event = {
        $case: 'checkboxHoverEvent',
        checkboxHoverEvent: CheckboxHoverEvent.fromPartial(object.event.checkboxHoverEvent),
      };
    }
    if (
      object.event?.$case === 'radioClickEvent' &&
      object.event?.radioClickEvent !== undefined &&
      object.event?.radioClickEvent !== null
    ) {
      message.event = {
        $case: 'radioClickEvent',
        radioClickEvent: RadioClickEvent.fromPartial(object.event.radioClickEvent),
      };
    }
    if (
      object.event?.$case === 'radioViewEvent' &&
      object.event?.radioViewEvent !== undefined &&
      object.event?.radioViewEvent !== null
    ) {
      message.event = {
        $case: 'radioViewEvent',
        radioViewEvent: RadioViewEvent.fromPartial(object.event.radioViewEvent),
      };
    }
    if (
      object.event?.$case === 'radioHoverEvent' &&
      object.event?.radioHoverEvent !== undefined &&
      object.event?.radioHoverEvent !== null
    ) {
      message.event = {
        $case: 'radioHoverEvent',
        radioHoverEvent: RadioHoverEvent.fromPartial(object.event.radioHoverEvent),
      };
    }
    if (
      object.event?.$case === 'inputViewEvent' &&
      object.event?.inputViewEvent !== undefined &&
      object.event?.inputViewEvent !== null
    ) {
      message.event = {
        $case: 'inputViewEvent',
        inputViewEvent: InputViewEvent.fromPartial(object.event.inputViewEvent),
      };
    }
    if (
      object.event?.$case === 'inputHoverEvent' &&
      object.event?.inputHoverEvent !== undefined &&
      object.event?.inputHoverEvent !== null
    ) {
      message.event = {
        $case: 'inputHoverEvent',
        inputHoverEvent: InputHoverEvent.fromPartial(object.event.inputHoverEvent),
      };
    }
    if (
      object.event?.$case === 'inputBlurEvent' &&
      object.event?.inputBlurEvent !== undefined &&
      object.event?.inputBlurEvent !== null
    ) {
      message.event = {
        $case: 'inputBlurEvent',
        inputBlurEvent: InputBlurEvent.fromPartial(object.event.inputBlurEvent),
      };
    }
    if (
      object.event?.$case === 'inputFocusEvent' &&
      object.event?.inputFocusEvent !== undefined &&
      object.event?.inputFocusEvent !== null
    ) {
      message.event = {
        $case: 'inputFocusEvent',
        inputFocusEvent: InputFocusEvent.fromPartial(object.event.inputFocusEvent),
      };
    }
    if (
      object.event?.$case === 'accordionClickEvent' &&
      object.event?.accordionClickEvent !== undefined &&
      object.event?.accordionClickEvent !== null
    ) {
      message.event = {
        $case: 'accordionClickEvent',
        accordionClickEvent: AccordionClickEvent.fromPartial(object.event.accordionClickEvent),
      };
    }
    if (
      object.event?.$case === 'accordionViewEvent' &&
      object.event?.accordionViewEvent !== undefined &&
      object.event?.accordionViewEvent !== null
    ) {
      message.event = {
        $case: 'accordionViewEvent',
        accordionViewEvent: AccordionViewEvent.fromPartial(object.event.accordionViewEvent),
      };
    }
    if (
      object.event?.$case === 'accordionHoverEvent' &&
      object.event?.accordionHoverEvent !== undefined &&
      object.event?.accordionHoverEvent !== null
    ) {
      message.event = {
        $case: 'accordionHoverEvent',
        accordionHoverEvent: AccordionHoverEvent.fromPartial(object.event.accordionHoverEvent),
      };
    }
    if (
      object.event?.$case === 'boxViewEvent' &&
      object.event?.boxViewEvent !== undefined &&
      object.event?.boxViewEvent !== null
    ) {
      message.event = {
        $case: 'boxViewEvent',
        boxViewEvent: BoxViewEvent.fromPartial(object.event.boxViewEvent),
      };
    }
    if (
      object.event?.$case === 'cardViewEvent' &&
      object.event?.cardViewEvent !== undefined &&
      object.event?.cardViewEvent !== null
    ) {
      message.event = {
        $case: 'cardViewEvent',
        cardViewEvent: CardViewEvent.fromPartial(object.event.cardViewEvent),
      };
    }
    if (
      object.event?.$case === 'textViewEvent' &&
      object.event?.textViewEvent !== undefined &&
      object.event?.textViewEvent !== null
    ) {
      message.event = {
        $case: 'textViewEvent',
        textViewEvent: TextViewEvent.fromPartial(object.event.textViewEvent),
      };
    }
    if (
      object.event?.$case === 'imageViewEvent' &&
      object.event?.imageViewEvent !== undefined &&
      object.event?.imageViewEvent !== null
    ) {
      message.event = {
        $case: 'imageViewEvent',
        imageViewEvent: ImageViewEvent.fromPartial(object.event.imageViewEvent),
      };
    }
    if (
      object.event?.$case === 'pageViewEvent' &&
      object.event?.pageViewEvent !== undefined &&
      object.event?.pageViewEvent !== null
    ) {
      message.event = {
        $case: 'pageViewEvent',
        pageViewEvent: PageViewEvent.fromPartial(object.event.pageViewEvent),
      };
    }
    if (
      object.event?.$case === 'sellDirectConversionEvent' &&
      object.event?.sellDirectConversionEvent !== undefined &&
      object.event?.sellDirectConversionEvent !== null
    ) {
      message.event = {
        $case: 'sellDirectConversionEvent',
        sellDirectConversionEvent: SellDirectConversionEvent.fromPartial(
          object.event.sellDirectConversionEvent,
        ),
      };
    }
    if (
      object.event?.$case === 'externalLeadGeneratedEvent' &&
      object.event?.externalLeadGeneratedEvent !== undefined &&
      object.event?.externalLeadGeneratedEvent !== null
    ) {
      message.event = {
        $case: 'externalLeadGeneratedEvent',
        externalLeadGeneratedEvent: ExternalLeadGeneratedEvent.fromPartial(
          object.event.externalLeadGeneratedEvent,
        ),
      };
    }
    if (
      object.event?.$case === 'sellerInputEvent' &&
      object.event?.sellerInputEvent !== undefined &&
      object.event?.sellerInputEvent !== null
    ) {
      message.event = {
        $case: 'sellerInputEvent',
        sellerInputEvent: SellerInputEvent.fromPartial(object.event.sellerInputEvent),
      };
    }
    if (
      object.event?.$case === 'partnerEvent' &&
      object.event?.partnerEvent !== undefined &&
      object.event?.partnerEvent !== null
    ) {
      message.event = {
        $case: 'partnerEvent',
        partnerEvent: PartnerEvent.fromPartial(object.event.partnerEvent),
      };
    }
    if (
      object.event?.$case === 'outreachEvent' &&
      object.event?.outreachEvent !== undefined &&
      object.event?.outreachEvent !== null
    ) {
      message.event = {
        $case: 'outreachEvent',
        outreachEvent: OutreachEvent.fromPartial(object.event.outreachEvent),
      };
    }
    message.customerContext =
      object.customerContext !== undefined && object.customerContext !== null
        ? CustomerContext.fromPartial(object.customerContext)
        : undefined;
    message.campaignContext =
      object.campaignContext !== undefined && object.campaignContext !== null
        ? CampaignContext.fromPartial(object.campaignContext)
        : undefined;
    message.leadContext =
      object.leadContext !== undefined && object.leadContext !== null
        ? LeadContext.fromPartial(object.leadContext)
        : undefined;
    message.sellDirectContext =
      object.sellDirectContext !== undefined && object.sellDirectContext !== null
        ? SellDirectContext.fromPartial(object.sellDirectContext)
        : undefined;
    message.adClickContext =
      object.adClickContext !== undefined && object.adClickContext !== null
        ? AdClickContext.fromPartial(object.adClickContext)
        : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string }
  ? { [K in keyof Omit<T, '$case'>]?: DeepPartial<T[K]> } & { $case: T['$case'] }
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<Exclude<keyof I, KeysOfUnion<P>>, never>;

function fromTimestamp(t: Timestamp): Date {
  let millis = t.seconds * 1_000;
  millis += t.nanos / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === 'string') {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
